import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import about from './About.module.css';
import { Link } from 'react-router-dom';


function About() {
    return (
        <Container fluid>
            <Row>
                <Col>
                    <div className={about.container}>
                        <figure>
                            <img id={about.lydiaphoto} src="img/IMG_8494.jpg" alt="Lydia"></img>
                        </figure>                    
                        <div className="centre">                        
                            <h2 className="white">
                                <span>ABOUT</span>
                            </h2>
                        </div>
                    </div>
                </Col>               
            </Row>
            <Row>
                <Col>
                    <div>
                        <div id={about.biotitle}>
                            <h5>About Me</h5>
                        </div>
                        <div>
                            <a href="https://www.conservationregister.com/acr-profile-page/2134/"><img id={about.iconimg} src="/img/ICON-accredited-member.jpg" alt="Accredited Member"></img></a>
                        </div>
                        <div>
                            <p className="centrep">
                                My name is Lydia Messerschmidt.  I am an object conservator working with a wide range of objects from different cultural backgrounds.
                            </p><p className="centrep">
                                My specialisation is organic materials. I especially enjoy working with feathers. This interest led me towards the collection and preservation of a variety of folding fans, and joining the <a style={{color:"inherit"}} href="https://fancircleinternational.org/">Fan Circle International</a>.
                            </p><p className="centrep">
                                I created this page to show a selection of my conservation work on fans and feather work, and share some intruiging insights about how these beautiful objects were made.
                            </p>
                        </div>
                        <div id={about.getintouch}>
                            <p>
                                <Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}>Get in Touch</Link>
                            </p>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default About;